import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import Close from "../../assets/images/close-black.svg";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { selectTermsAndConditionsSelector } from "../../store/cmsBlock/selector";
import { cmsBlockActionDispatch } from "../../store/cmsBlock/actions";
import { cmsBlockKeys } from "../../utils/constants";
import cmsBlockServicesInstance from "../../services/cmsBlockService";
import { TermsAndConditionsModalLoader } from "../loaders/productLoaders";
import { IoMdClose } from "react-icons/io";
import { appendUtmParamsToLinks } from "../../utils/utility";

type ModalProps = {
  close: (value: boolean) => void;
  check: (value: boolean) => void;
};

const Modal: React.FC<ModalProps> = ({ close, check }) => {
  const termsContent = useRef<HTMLDivElement | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
  const termsCMSPage = useAppSelector(selectTermsAndConditionsSelector);

  const { setTermsAndConditions } = cmsBlockActionDispatch(useAppDispatch());

  useEffect(() => {
    cmsBlockServicesInstance.setCMSPages(
      cmsBlockKeys.termsConditions,
      setTermsAndConditions,
      () => setLoading(false)
    );
  }, [setTermsAndConditions]);

  const extractedText = termsCMSPage?.content
    ? new DOMParser().parseFromString(termsCMSPage?.content, "text/html").body
        .textContent || ""
    : "";
       const modifiedText = appendUtmParamsToLinks(extractedText);
  const scrollFn = () => {
    if (
      termsContent.current &&
      Math.round(
        termsContent.current.scrollTop + termsContent.current.clientHeight
      ) >
        Math.round(termsContent.current.scrollHeight) - 2
    ) {
      setButtonEnabled(true);
      termsContent.current.closest(".modal")?.classList.add("scrollBottom");
    } else {
      termsContent.current?.closest(".modal")?.classList.remove("scrollBottom");
    }
  };

  const closeModal = () => {
    document.body.classList.remove("modal-open");
    close(false);
  };

  const uncheckCheckbox = () => {
    closeModal();
    check(false);
  };

  return (
    <div className="modal modal--open terms-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h1>
            <span>Terms and Conditions</span>
            <button
              data-track="close-button"
              className="close"
              onClick={uncheckCheckbox}
            >
              <IoMdClose className="close-icon" />
            </button>
          </h1>
        </div>
        <div className="modal-body">
          <h2 className="content-heading">
            Please read through all the Terms and Conditions to activate the
            'Accept' button.
          </h2>
          {!loading ? (
            <section className="terms-container">
              <div
                className="terms-content"
                ref={termsContent}
                onScroll={scrollFn}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: modifiedText.replace(
                      /<h2 class="ln-section__heading">TERMS AND CONDITIONS<\/h2>/,
                      ""
                    ),
                  }}
                />
              </div>
            </section>
          ) : (
            <TermsAndConditionsModalLoader />
          )}
        </div>
        <div className="modal-footer">
          <div className="btn-container">
            <button
              data-track="cancel-button"
              className="btn btn-secondary"
              onClick={uncheckCheckbox}
            >
              Cancel
            </button>
            <button
              data-track="accept-button"
              className="btn btn--primary"
              disabled={!buttonEnabled}
              onClick={closeModal}
            >
              Accept Terms and Conditions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
